import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const ReservationsPage = () => {
  const [reservations, setReservations] = useState([]);
  const [tables, setTables] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    customer_name: '', customer_phone: '', customer_email: '',
    guests_count: 2, reservation_date: '', reservation_time: '',
    table_id: '', notes: '',
  });

  useEffect(() => {
    fetchReservations();
  }, []);

  // Se dispara automáticamente cuando fecha, hora o comensales cambian (con los valores
  // ya actualizados, no los del render anterior) — antes se llamaba a mano dentro de cada
  // onChange y usaba datos viejos, por eso casi nunca aparecían mesas disponibles.
  useEffect(() => {
    fetchAvailableTables();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.reservation_date, form.reservation_time, form.guests_count]);

  const fetchReservations = async () => {
    try {
      const res = await api.get('/reservations');
      setReservations(res.data.data || []);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const fetchAvailableTables = async () => {
    if (!form.reservation_date || !form.reservation_time || !form.guests_count) return;
    try {
      const res = await api.get('/reservations/available-tables', {
        params: {
          branch_id: 1,
          date: form.reservation_date,
          time: form.reservation_time,
          guests: form.guests_count,
        }
      });
      setTables(res.data.data || []);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const createReservation = async (e) => {
    e.preventDefault();
    try {
      await api.post('/reservations', { ...form, branch_id: 1 });
      setShowForm(false);
      setForm({ customer_name: '', customer_phone: '', customer_email: '', guests_count: 2, reservation_date: '', reservation_time: '', table_id: '', notes: '' });
      fetchReservations();
    } catch (err) {
      alert(err.response?.data?.message || 'Error');
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`/reservations/${id}/status`, { status });
      fetchReservations();
    } catch (err) {
      alert('Error');
    }
  };

  const statusColors = {
    pending: '#f59e0b', confirmed: '#3b82f6', seated: '#10b981',
    cancelled: '#ef4444', no_show: '#64748b',
  };

  const statusLabels = {
    pending: 'Pendiente', confirmed: 'Confirmada', seated: 'Sentado',
    cancelled: 'Cancelada', no_show: 'No Show',
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ color: '#e2e8f0', fontSize: 28 }}>📅 Reservas</h1>
        <button onClick={() => setShowForm(!showForm)} className="btn btn-primary">
          {showForm ? 'Cancelar' : '+ Nueva Reserva'}
        </button>
      </div>

      {showForm && (
        <div className="card animate-fade-in" style={{ marginBottom: 24 }}>
          <h3 style={{ color: '#e2e8f0', marginBottom: 16 }}>Nueva Reserva</h3>
          <form onSubmit={createReservation} style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
            <input type="text" placeholder="Nombre cliente *" className="input" value={form.customer_name} onChange={e => setForm({...form, customer_name: e.target.value})} required />
            <input type="tel" placeholder="Teléfono" className="input" value={form.customer_phone} onChange={e => setForm({...form, customer_phone: e.target.value})} />
            <input type="email" placeholder="Email" className="input" value={form.customer_email} onChange={e => setForm({...form, customer_email: e.target.value})} />
            <input type="date" className="input" value={form.reservation_date} onChange={e => setForm({...form, reservation_date: e.target.value})} required />
            <input type="time" className="input" value={form.reservation_time} onChange={e => setForm({...form, reservation_time: e.target.value})} required />
            <input type="number" placeholder="Comensales" className="input" value={form.guests_count} onChange={e => setForm({...form, guests_count: parseInt(e.target.value) || ''})} min={1} max={50} required />
            <select className="input" value={form.table_id} onChange={e => setForm({...form, table_id: e.target.value})}>
              <option value="">Mesa (opcional)</option>
              {tables.map(t => <option key={t.id} value={t.id}>Mesa {t.number} — {t.name} ({t.capacity} pers.)</option>)}
            </select>
            <input type="text" placeholder="Notas" className="input" value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} />
            <button type="submit" className="btn btn-success">Crear Reserva</button>
          </form>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {reservations.map(r => (
          <div key={r.id} className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                <span style={{ color: '#e2e8f0', fontWeight: 600, fontSize: 16 }}>{r.customer_name}</span>
                <span style={{
                  padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600,
                  background: statusColors[r.status] + '20', color: statusColors[r.status],
                }}>{statusLabels[r.status]}</span>
              </div>
              <p style={{ color: '#94a3b8', fontSize: 13 }}>
                📅 {r.reservation_date} · 🕐 {r.reservation_time} ·
                👥 {r.guests_count} pers. {r.table && `· 🪑 Mesa ${r.table.number}`}
              </p>
              {r.notes && <p style={{ color: '#64748b', fontSize: 12, marginTop: 4 }}>📝 {r.notes}</p>}
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              {r.status === 'pending' && (
                <button onClick={() => updateStatus(r.id, 'confirmed')} className="btn btn-primary" style={{ padding: '6px 12px', fontSize: 12 }}>Confirmar</button>
              )}
              {r.status === 'confirmed' && (
                <button onClick={() => updateStatus(r.id, 'seated')} className="btn btn-success" style={{ padding: '6px 12px', fontSize: 12 }}>Sentar</button>
              )}
              {(r.status === 'pending' || r.status === 'confirmed') && (
                <button onClick={() => updateStatus(r.id, 'cancelled')} className="btn btn-danger" style={{ padding: '6px 12px', fontSize: 12 }}>Cancelar</button>
              )}
            </div>
          </div>
        ))}
        {reservations.length === 0 && (
          <p style={{ color: '#64748b', textAlign: 'center', padding: 40 }}>No hay reservas registradas</p>
        )}
      </div>
    </div>
  );
};

export default ReservationsPage;